//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React from 'react';

import classNames    from 'classnames';
import { keyframes } from 'styled-components';
import styled        from 'styled-components';

import DefaultTypes from '@components/DefaultTypes';
import PropTypes    from '@components/PropTypes';

import styles from './styles.module.scss';

const propTypes = {
    isLoading:             PropTypes.bool,
    loadingOverlayClicked: PropTypes.func,
    text:                  PropTypes.string,
};

/* eslint-disable rulesdir/no-repeatedly-props-use-constant */
const loadingAnimation = (color) => keyframes`
    from
    {
        box-shadow: 0 0 0 0 ${color};
    }

    to
    {
        box-shadow: 0 0 0 200px transparent;
    }

`;

const LoadingOverlayPulseWrapper = styled.div`
    span
    {
        background: ${(props) => props.theme.secondaryColor} !important;
        animation:  ${(props) => loadingAnimation(props.theme.secondaryColor)} 1.3s infinite !important;

    }
`;
/* eslint-enable rulesdir/no-repeatedly-props-use-constant */

const LoadingOverlay = ({
    isLoading             = false,
    loadingOverlayClicked = DefaultTypes.func,
    text                  = '',
}) => {
    return (
        <div
            className={classNames(
                styles.loadingOverlay,
                {
                    [styles.loadingOverlayVisible]: isLoading,
                },
            )}
        >
            <LoadingOverlayPulseWrapper
                className={styles.loadingOverlayPulse}
                aria-label={text}
            >
                <span onClick={loadingOverlayClicked} />
                <div
                    className={styles.loadingOverlayText}
                >
                    {text}
                </div>
            </LoadingOverlayPulseWrapper>
        </div>
    );
};

LoadingOverlay.propTypes = propTypes;

export default LoadingOverlay;
